import axios from 'axios';
import { MemberRootDetail, TicketDetailRoot } from './types';
import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
const rootUrl = process.env['NX_VAUNCE_APP_V2_API_URL'] ?? '';
const posRootUrl = process.env['NX_POS_API_URL'] || 'http://localhost:8080';

export const VaunceAppV2Api = {
	scan방문등록ForTickets: async (qrCode: string, posStoreId: number) => {
		return (
			await posAxiosClient.get<{ body: TicketDetailRoot }>(
				`${posRootUrl}/mobile-waiver/app/store-visit/ticket-detail`,
				{
					params: {
						qrCode,
						posStoreId,
					},
				}
			)
		).data.body;
	},
	scan방문등록ForGuestVisits: async (qrCode: string) => {
		return (
			await axios.get<{ body: MemberRootDetail }>(`${rootUrl}/api/pos/store-visit/members`, {
				params: {
					qrCode,
				},
			})
		).data.body;
	},
};
